import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Note, Page, Steps } from "../../../helbest";
import CartItem from "../../components/CartItem/CartItem";
import EmptyCart from "./EmptyCart/EmptyCart";
import CartFooter from "./CartFooter/CartFooter";
import Summery from "./Summery/Summery";
import { useCheckoutQuery } from "../../../saleor/api";
import { calculator } from "../../../base/utils";
import { CartItemTransformer } from "../../../services/objectTransformer/cart";
import { useTranslation } from "react-i18next";
import Loading from "../../components/Loading/Loading";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import useProductItem from "../../components/ProductItem/useProductItem"; 

const Cart = () => {
  const Login = useSelector((state) => state.Login);
  const { t } = useTranslation();
  const { add_pending_cart_item } = useProductItem();

  const {
    data: checkoutData,
    refetch: checkoutRefetch,
    loading,
  } = useCheckoutQuery({
    variables: {
      id: Login.checkoutId,
    },
    onError: (error) => {
      Note.error(error.message);
    },
    skip: !Login.token || !Login.checkoutId,
  });

  const cart = (checkoutData?.checkout?.lines || []).map((line) =>
    CartItemTransformer(line),
  );

  useEffect(() => {
    calculator();
  }, []);

  useEffect(() => {
    if (Login.is_login) {
      const hasPending = localStorage.getItem("pending_cart_item");
      if (hasPending) {
        add_pending_cart_item();
      }
    }
  }, [Login.is_login]);

  return (
    <Page
      className="page-cart bg-gray-light"
      title={t("common.cart")}
      footer={<CartFooter cart={cart} />}
      showFooter
      customHeader={<HeaderBack title={t("common.cart")} url={"/"} />}
      headerFix
      extra_header={<Steps step={1} hasShadow />}
      logo
      back
      address="/"
    >
      {loading ? (
        <div className="text-center mt-5">
          <Loading />
        </div>
      ) : cart.length === 0 ? (
        <EmptyCart />
      ) : (
        cart.length > 0 && (
          <section className="cart-page-body">
            <div className="cart-item-container">
              {cart.map((cart_item) => {
                return (
                  <CartItem
                    key={cart_item.id || cart_item.product?.id}
                    data={cart_item.product}
                    checkoutLineId={cart_item.id}
                    checkoutRefetch={checkoutRefetch}
                  />
                );
              })}
              <Summery tax={checkoutData?.checkout?.totalPrice.tax} />
            </div>
          </section>
        )
      )}
    </Page>
  );
};

export default Cart;
